/**
 * For use with GambleSpin
 */
var arrowManager = {};

arrowManager.create = function() {
    return new PIXI.Graphics();
};

arrowManager.initialise = function(json, arrow) {
    arrowManager.setupFunctions(arrow);
    arrow.arrowParams = {};
    arrow.arrowParams.innerColour = 0x00FF00;
    arrow.arrowParams.outerColour = 0x000000;
    arrow.arrowParams.alpha = 0.3;

    arrow.set(json.startX, json.startY, json.endX, json.endY, json.arrowSize, json.shaftThickness);
};

arrowManager.getFilesRequired = function(json) {
    return [];
};

arrowManager.set = function(startX, startY, endX, endY, arrowSize, shaftThickness) {
    checkForUndefined(startX, "startX is not defined for " + this.name);
    checkForUndefined(startY, "startY is not defined for " + this.name);
    checkForUndefined(endX, "endX is not defined for " + this.name);
    checkForUndefined(endY, "endY is not defined for " + this.name);
    checkForUndefined(arrowSize, "arrowSize is not defined for " + this.name);
    checkForUndefined(shaftThickness, "shaftThickness is not defined for " + this.name);

    this.arrowParams.start = {x: startX, y:startY};
    this.arrowParams.end = {x: endX, y:endY};
    this.arrowParams.arrowSize = arrowSize;
    this.arrowParams.shaftThickness = shaftThickness;

    this.redraw();
};

arrowManager.setColour = function(innerColour, outerColour, alpha) {
    this.arrowParams.innerColour = innerColour;
    this.arrowParams.outerColour = outerColour;
    this.arrowParams.alpha = alpha;
};

arrowManager.setStart = function(x, y) {
    this.arrowParams.start = {x: x, y:y};
    this.redraw();
};

arrowManager.setEnd = function(x, y) {
    this.arrowParams.end = {x: x, y:y};
    this.redraw();
};

arrowManager.setArrowSize = function(size) {
    this.arrowParams.arrowSize = size;
    this.redraw();
};

arrowManager.redraw = function() {
    var sx = this.arrowParams.start.x;
    var sy = this.arrowParams.start.y;
    var ex = this.arrowParams.end.x;
    var ey = this.arrowParams.end.y;
    var ox = ex-sx;
    var oy = ey-sy;

    // Calculate radians of angles
    var radUp = Math.atan2(ox, oy);
    var radLeft = radUp + Math.PI * 0.5;
    var radDown = radUp + Math.PI;
    var radRight = radUp + Math.PI * 1.5;

    // Calculate line lengths
    var lineLength = Math.sqrt(ox*ox + oy*oy);
    var endLength = this.arrowParams.shaftThickness / 2;
    var shaftLength = lineLength - this.arrowParams.arrowSize;
    var arrowBackLength = this.arrowParams.arrowSize * 0.8;

    var path = [];
    path.push(sx,sy);
    path.push(sx + Math.sin(radLeft) * endLength, sy + Math.cos(radLeft) * endLength);
    path.push(path[2] + Math.sin(radUp) * shaftLength, path[3] + Math.cos(radUp) * shaftLength);
    path.push(path[4] + Math.sin(radLeft) * arrowBackLength, path[5] + Math.cos(radLeft) * arrowBackLength);
    path.push(ex,ey);
    path.push(sx + Math.sin(radUp) * shaftLength + Math.sin(radRight) * (endLength + arrowBackLength), sy + Math.cos(radUp) * shaftLength + Math.cos(radRight) * (endLength + arrowBackLength));
    path.push(sx + Math.sin(radUp) * shaftLength + Math.sin(radRight) * endLength, sy + Math.cos(radUp) * shaftLength + Math.cos(radRight) * endLength);
    path.push(sx + Math.sin(radRight) * endLength, sy + Math.cos(radRight) * endLength);
    path.push(sx,sy);

    this.clear();
    this.lineStyle(5, this.arrowParams.outerColour, 1);
    this.beginFill(this.arrowParams.innerColour, this.arrowParams.alpha);
    this.drawPolygon(path);
    this.endFill();
};

arrowManager.setupFunctions = function(arrow) {
    arrow.setStart = arrowManager.setStart;
    arrow.setEnd = arrowManager.setEnd;
    arrow.set = arrowManager.set;
    arrow.redraw = arrowManager.redraw;
    arrow.setColour = arrowManager.setColour;
};


resourceManager.registerObjectType("arrow", arrowManager.create, arrowManager.initialise, arrowManager.getFilesRequired);
